fragment EmailSequenceTemplateStubBasic on EmailSequenceTemplate {
    id
    name
    creatorUser {
        id
        name
        isEnabled
    }
    lastSentTime
    isShared
    canEdit
    parent {
        id
        creatorUser {
            id
            name
            isEnabled
        }
    }
    emailAutomation {
        id
        entersStage {
            id
            stageset {
                id
                name
            }
        }
    }
    group {
        id
        name
    }
    deletedTime
}
